import { Link } from 'react-router-dom';
import { FormikValues, useFormikContext } from 'formik';

import { Routes } from 'config';

import { Button } from '../button';

import { AuthActionFooterProps } from './types';

export const AuthActionFooter = <T extends FormikValues>({
  footerNode,
  confirmButtonText,
  footerText = 'Back to',
  hideFooterLink = false,
  link = Routes.Auth.Login,
  footerButtonText = 'Sign In',
}: AuthActionFooterProps) => {
  const { dirty, isSubmitting } = useFormikContext<T>();

  return (
    <div className="flex flex-col gap-4">
      <Button type="submit" disabled={!dirty || isSubmitting}>
        {confirmButtonText}
      </Button>

      {footerNode}

      {!hideFooterLink && (
        <div className="flex items-center justify-center gap-1">
          <p className="text-base">{footerText}</p>
          <Button
            to={link}
            variant="text"
            component={Link}
            textClassName="text-base"
            buttonClassName="h-auto min-w-0 p-0"
          >
            {footerButtonText}
          </Button>
        </div>
      )}
    </div>
  );
};
